// JWT Utility Functions

// Helper function to decode a JWT
function decodeJWT(token) {
    try {
        const payloadBase64 = token.split('.')[1];
        const payload = atob(payloadBase64);
        return JSON.parse(payload);
    } catch (error) {
        console.error("Failed to decode JWT", error);
        return null;
    }
}

// Function to get the subject (sub) from the JWT
function getJWTSub() {
    const isaacToken = localStorage.getItem('isaacToken');
    if (!isaacToken) {
        console.error("No isaacToken found in localStorage");
        return null;
    }

    const decoded = decodeJWT(isaacToken);
    return decoded ? decoded.sub : null;
}

// Role
function getJWTRole() {
    const isaacToken = localStorage.getItem('isaacToken');
    if (!isaacToken) {
        console.error("No isaacToken found in localStorage");
        return null;
    }

    const decoded = decodeJWT(isaacToken);
    return decoded ? decoded.roles : [];
}

// Function to get the Bearer string for authorization headers
function getBearerString() {
    const isaacToken = localStorage.getItem('isaacToken');
    if (!isaacToken) {
        console.error("No isaacToken found in localStorage");
        return null;
    }
    return `Bearer ${isaacToken}`;
}

export { decodeJWT, getJWTSub, getJWTRole, getBearerString };
